import { z } from 'zod';

export const syncDataTypeSchema = z.enum(['diaryEntries', 'userFoods', 'recipes', 'goals', 'weightEntries', 'meals']);
export type SyncDataType = z.infer<typeof syncDataTypeSchema>;

export const syncDataTypesConfigurationSchema = z.object({
  diaryEntries: z.boolean(),
  userFoods: z.boolean(),
  recipes: z.boolean(),
  goals: z.boolean(),
  weightEntries: z.boolean(),
  meals: z.boolean(),
});

export const syncAutoSyncConfigurationSchema = z.object({
  enabled: z.boolean(),
  intervalMinutes: z.number(),
  onlyOnWifi: z.boolean(),
});

export const syncConfigurationSchema = z.object({
  id: z.string(),
  enabled: z.boolean(),
  dataTypes: syncDataTypesConfigurationSchema,
  autoSync: syncAutoSyncConfigurationSchema,
  updatedAt: z.string(),
});
export type SyncConfiguration = z.infer<typeof syncConfigurationSchema>;
